
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/canal-etic",
      function () {
        return require("private-next-pages/corporatiu/canal-etic/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/canal-etic"])
      });
    }
  